import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios'
import Navbar from '../../home/navbar';

import Footer from '../../home/footer';
import { PostCard } from './post_card';
import { PostProfile } from './post_profile';
import postpng from '../images/post.png'
import image_svg from '../images/image_svg.png'
import video_svg from '../images/video_svg.png'
import padlock from '../images/padlock.png'
import { Community_Nav } from '../community_nav';
import CountryContext from '../../home/country_context';
import { BeatLoader, SyncLoader } from 'react-spinners';
import { url } from '../../weburl';
import $ from 'jquery';
import 'bootstrap'
import { useAuthState } from 'react-firebase-hooks/auth';
import { IconButton, Typography } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';

export const Post = () => {
    const contextData = useContext(CountryContext)
    const [posts, setPosts] = useState({})
    const [posts_loaded, setPostsLoaded] = useState(false)
    const [modal, setModal] = useState(false)
    const [posts_counter, setPostsCounter] = useState(1)
    const [refreshCounter, setRefreshCounter] = useState(0)
    const [newPost, setNewPost] = useState({})
    const [imageSelected, setImageSelected] = useState()

    useEffect(() => {
        getPosts()
    }, [])

    useEffect(() => {
        getPosts()
    }, [contextData.refreshCounter])

    // useEffect(() => {
    //     if (posts) {
    //         setPostsLoaded(true)
    //     }

    // }, [posts])

    const getPosts = () => {
        setPostsCounter(posts_counter + 1)
        axios
            .get(`${url}api/posts`)
            .then((res) => {
                console.log('getting all posts', res.data)
                setPosts(res.data)
                setPostsLoaded(true)

            })
            .catch((err) => console.log(err))
    }

    const displayPosts = () => {
        return Object.keys(posts).map((key) => {
            return <div className='w-100 mb-0'>
                <PostCard key={posts[key]['id']}
                    user_id={posts[key]['id']}
                    post_user={posts[key]['username']}
                    post_id={posts[key]['_id']}
                    post_content={posts[key]['content']}

                    post_image={`https://res.cloudinary.com/daurieb51/image/upload/v1654276166/${posts[key]['image_public_id']}.jpg`}
                    time={posts[key]['timestamp']}
                    likes={posts[key]['likes']}
                />
            </div>

        })
    }



    const handleChange = (e) => {
        e.preventDefault()
        const { name, value } = e.target
        console.log(name, value)
        setNewPost({ [name]: value })

    }
    const addImageSelected = (e) => {
        setImageSelected(e.target.files[0])

    }


    const handleImageChange = (e) => {
        console.log(e.target.files[0].name)
        setNewPost({ ...newPost, image_url: e.target.files[0].name })
        addImageSelected(e)


    }
    useEffect(() => {
        if (newPost.public_id) {
            sendPostInfo()
            console.log('sending post')
        }

    }, [newPost.public_id])


    const uploadImage = (callback) => {
        const formData = new FormData()
        formData.append('file', imageSelected)
        formData.append('upload_preset', 'gwxgv5ii')
        axios.post('https://api.cloudinary.com/v1_1/daurieb51/image/upload', formData)
            .then((response) => {
                setNewPost({ ...newPost, public_id: response.data.public_id })
                console.log('responseeeee', response.data.public_id)
                console.log('image successfuly uploaded thank you jehovah')
            })


    }

    const sendPostInfo = () => {
        console.log('submitting post details')
        axios
            .post(`${url}api/posts`,
                {
                    content: newPost.post_content,
                    public_id: newPost.public_id,
                    user: contextData.user
                })
            .then((res) => {
                console.log(res)
                setNewPost({})
                contextData.refresh()
            })
            .catch((err) => console.log(err))
    }

    const submitPost = (e) => {
        e.preventDefault()
        console.log('here in the loop')

        if (imageSelected) {
            console.log('this .state.image selected present')
            uploadImage(sendPostInfo)

        }
        else {
            console.log('there is no image selected')
            sendPostInfo()
        }

    }

    return (

        <div className='container-fluid '>
            <Community_Nav />

            <div className='row justify-content-center align-items-start '>
                <div className='col-md-2 mt-5 '>
                    {/* <p className='text-uppercase  py-3 font-weight-bold'> Profile</p> */}

                    {contextData.user ? <PostProfile /> :
                        <div className='text-dark bg-md-white p-5 border border-gold_'>
                            <p className='text-dark font-weight-bold mb-0'>Looks like you are not logged in/signed up</p>
                            <p className='text-warning mb-0'>Login</p>
                            <p className='text-warning mb-0'>Sign up</p>
                        </div>
                    }
                </div>


                <div className='col-md-6'>
                    <p className='text-uppercase font-weight-bold mt-2 animate__animated animate__fadeInDown animate__slower'>AFBR's latest posts</p>
                    {posts_loaded ? displayPosts() : <div className='mt-5'>
                        <SyncLoader color='#ba8108'/>
                        <p className='font-weight-bold text-dark'>Loading posts</p>

                    </div>}

                </div>
                {contextData.user ? <div className='col-md-2 mt-5 '>

                    <div className='animate__animated animate__fadeInDown rounded
                        animate__slower'>
                        <button type="button" class="btn btn-outline-warning"
                            onClick={() => setModal(!modal)} data-toggle="modal" data-target="#exampleModalCenter">
                            <img src={postpng} alt="" width={'50px'} />
                        </button>
                        <p className=' font-italic text-dark'>
                            Share your thoughts with the community!!</p>
                    </div>

                </div> :
                    <div className='col-md-2'>
                    </div>}

                {/* modal */}
                {modal ?


                    <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLongTitle">Add a Post</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div className='container-fluid'>
                                        <div className='row align-items-center justify-content-start'>
                                            <div className='col-md-10'>
                                                <form className='text-dark' method='post' onSubmit={(e) => {
                                                    submitPost(e)
                                                }}>
                                                    <div class="form-group text-left" >
                                                        {/* <label className='text-dark ' for="postContent">Add a post</label> */}
                                                        <textarea class="form-control" id="postContent" placeholder='Feel free!!!'
                                                            name='post_content' onChange={handleChange} rows="3" required></textarea>
                                                    </div>
                                                    <div class="form-group text-dark  text-left">
                                                        <label className='text-dark' for="sendfile">
                                                            <img src={image_svg} alt="" width={'5%'} />
                                                            Post an image</label>
                                                        <input type="file" className='modal-image-button form-control-file' name='post_image'
                                                            onChange={handleImageChange} id="sendfile"></input>
                                                    </div>
                                                    {/* <IconButton color="primary" aria-label="upload picture" component="label">
                                                        <input hidden name='post_image' accept="image/*" type="file" onChange={handleImageChange}/>
                                                        <PhotoCamera variant='primary'/>
                                                        <Typography>&nbsp; Upload Image</Typography>
                                                    </IconButton> */}
                                                    {/* <div class="form-group  text-left ">
                                                            <label className='text-dark' for="exampleFormControlFile1"><img src={video_svg} alt="" width={'5%'} />  post a video</label>
                                                            <input type="file" class="form-control-file" name='post_video'
                                                                onChange={this.handleChange} id="exampleFormControlFile1"></input>
                                                        </div> */}
                                                    <div class="modal-footer">
                                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                                        <button type="submit" class="btn btn-success" onClick={e => submitPost(e)} data-dismiss='modal'>Post</button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div> : null}

            </div>

        </div>



    )

}
